import type { BaseComponentProps } from "@q4/nimbus-ui";

export interface EditButtonProps extends BaseComponentProps {
  userContext?: Record<string, unknown>;
  disabled?: boolean;
  onClick: () => void;
}

export enum EditButtonClassName {
  Base = "edit-button",
}
